import React, { Component } from 'react';
import * as enums from '../../../utils/EnumMapping';
import MainTable from '../../common/table/MainTable';
import * as columns from './BankAccountNumberColumns';
import NewBankAccountNumber from './NewBankAccountNumber';

class BankAccountNumber extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "BANK_ACCOUNT_NUMBER";
            item.partnerTypeLabel = enums.getLabel(enums.partnerTypes, item.partnerType);
            return item;
        })
        return data;
    }

    render() {
        return (
            <MainTable
                divClassName="bankAccountNumber"
                tableName="Bankszámlaszámok"
                newObjectLabel="Új bankszámlaszám hozzáadása"
                path='/api/bankaccountnumbers'
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                dialogContent={(refresh, close) => <NewBankAccountNumber refresh={refresh} close={close} />} />
        );
    }
}

export default BankAccountNumber;